module.exports = __webpack_public_path__ + "img/e18c5f0.jpg";